import { render } from "./ResetPendingNoticeHost.vue?vue&type=template&id=1d616b36"
import script from "./ResetPendingNoticeHost.vue?vue&type=script&lang=js"
export * from "./ResetPendingNoticeHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__